
































import { defineComponent, ref, watch } from '@vue/composition-api';
import { useSession } from '@/bundles/Session/composables/useSession';
import { debounce } from '@/bundles/App/helpers';
import { useActivityGroup } from '@/bundles/ActivityGroup/composables/useActivityGroup';
import { ActivityGroupType } from '@/bundles/ActivityGroup/types';

export default defineComponent({
  emits: ['list:refresh'],

  setup(_, { emit }) {
    const { pending: sessionLoading, session, fetch } = useSession();

    const sessionKeyword = ref('');
    const selected = ref(null);

    function keywordSearch () {
      if (!sessionKeyword.value?.length) {
        return fetch([{ name: 'active', value: true }]);
      }
      fetch([{ name: 'keyword', value: sessionKeyword.value }, { name: 'active', value: true }]);
    }
    const searchWrapper = debounce(keywordSearch, 500);
    watch(sessionKeyword, () => {
      searchWrapper();
    });

    const { addToGroup, addToGroupLoading } = useActivityGroup();
    async function submitEventHandler () {
      if (!selected.value) {
        return;
      }
      await addToGroup(ActivityGroupType.voice_builder, { record_id: (selected.value as unknown as number) });
      clearForm();
      emit('list:refresh');
    }

    function clearForm() {
      selected.value = null;
      sessionKeyword.value = '';
    }

    return {
      sessionKeyword,
      selected,
      session,
      addToGroupLoading,
      sessionLoading,
      submitEventHandler,
    };
  },
});
